<swiper-container #privateSwiper
  class="image-swiper"
  *ngIf="!isPublic && images?.length > 0"
  
>

  <!-- Slides -->
  <swiper-slide *ngFor="let img of images" class="is-flex" data-e2e="app-screenshot">
    <ng-container *ngIf="isDeleteAbility">
      <div
        class="delete"
        *restrictPermission="['delete-screenshot']"
        (click)="deleteImage(img)"
      ></div>
    </ng-container>
    <img *ngIf="img" [src]="img?.publicUrl | secureLoad | async" alt="screenshot" />
  </swiper-slide>
</swiper-container>

<swiper-container #publicSwiper
  class="image-swiper"
  *ngIf="isPublic && images?.length > 0"
>

  <!-- Slides -->
  <swiper-slide *ngFor="let img of images" class="is-flex" data-e2e="app-screenshot">
    <ng-container *ngIf="isDeleteAbility">
      <div
        class="delete"
        *restrictPermission="['delete-screenshot']"
        (click)="deleteImage(img)"
      ></div>
    </ng-container>
    <img [src]="img.publicUrl | secureLoad | async" alt="screenshot" />
  </swiper-slide>
</swiper-container>

<!-- Pagination -->
<div class="pagination-wrapper">
  <div class="swiper-pagination" data-e2e="swiper-pagination"></div>
</div>
